import { styled, DialogActions } from '@mui/material';

export const AssistantGenerateRoutesDialogByItemsContentActionsContainer =
  styled(DialogActions)({
    justifyContent: 'space-between',
  });
